<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { webChart } from "./data-web";
import Stat from "@/components/widgets/stat";
import { employeeList } from "./data-employee";

export default {
  page: {
    title: "Web Control Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, simplebar, PageHeader, Stat, DatePicker },
  data() {
    return {
      loginData: {},
      currEmp: {
        empId: 0,
        companyId: 0,
        teamId: 0,
        name: "N.A",
        email: "N.A",
        designation: "N.A",
        timezone: "N.A",
        image: "N.A",
        gender: "N.A",
        country: "N.A",
        ruleId: 0,
        validity: 0,
        activationTime: 0,
        lastSeenTime: 0,
      },
      employeeList: employeeList,
      employees: [],
      webChart: webChart,
      title: "Web Control Report",
      webDashboardLoader: false,
      webDataLoader: false,
      empLoader: false,
      tableWebData: [
      ],
      webGraphData: [],
      webDate: "",
      selectedDate: "",
      filterValue: "",
      filterUrlValue: "",
      statData: [
        {
          icon: "bx bx-time",
          title: 'menuitems.reports.thisYear',
          value: "0 hrs",
        },
        {
          icon: "bx bx-hourglass",
          title: 'menuitems.reports.thisMonth',
          value: "0 hrs",
        },
        {
          icon: "bx bx-analyse",
          title: 'menuitems.reports.today',
          value: "0 hrs",
        },
      ],
    };
  },
  methods: {
    async getAllEmployees() {
      this.empLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.employees = response.data.data;
            this.curr = this.employees[0];
            this.getApiData();
            this.empLoader = false;
          }
        }
      } catch (error) {
        this.empLoader = false;
      }
    },
    async getWebData() {
      this.webDataLoader = true;
      this.tableWebData = [];
      try {
        const response = await axios.get(process.env.VUE_APP_WEB_URL + "/web_report/logs", {
          params: {
            companyId: this.curr.companyId,
            empId: this.curr.empId,
            date: this.selectedDate,
            timezone: this.curr.timezone,
          },
        });
        if(response.data.success == "true") {
          this.tableWebData = response.data.data;
          for(var i = 0;i < this.tableWebData.length;i++) {
            let domain = (new URL(this.tableWebData[i].url));
            domain = domain.origin;
            let path = this.tableWebData[i].url.slice(domain.length);
            this.tableWebData[i].url = '<strong>' + domain + '</strong>' + path;
          }
        }
        this.webDataLoader = false;
      } catch (error) {
        this.webDataLoader = false;
      }
    },
    async getWebDashboardData() {
      this.webDashboardLoader = true;
      this.statData[0].value = "0";
      this.statData[1].value = "0";
      this.statData[2].value = "0";
      try {
        const response = await axios.get(
          process.env.VUE_APP_WEB_URL + "/web_report/web_dashboard",
          {
            params: {
              companyId: this.curr.companyId,
              empId: this.curr.empId,
            },
          }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          this.statData[0].value = response.data.data.thisYearCount.toString();
          this.statData[1].value = response.data.data.thisMonthCount.toString();
          this.statData[2].value = response.data.data.todayCount.toString();
          this.webDashboardLoader = false;
        }
      } catch (error) {
        this.webDashboardLoader = false;
      }
    },
    getApiData() {
      this.getWebDashboardData();
      this.getWebData();
    },
    onEmployeeChange(data) {
      this.curr = data;
      this.webDate = new Date();
      this.selectedDate = this.webDate.toISOString().slice(0,10);

      this.getApiData();
    },
    onDateChange() {
      if(this.webDate == null) {
        this.selectedDate = "";
        return;
      }
      var date = new Date(this.webDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      console.log(this.selectedDate);
      this.getWebData();
    },
  },

  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.webDate = new Date();
    var date = new Date(),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    this.selectedDate = [date.getFullYear(), mnth, day].join("-");
    this.getAllEmployees();
  },
  computed: {
    searchevents: function(){
      var result = this.employees;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) ||
          event.email.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
    searchUrlevents: function(){
      var result = this.tableWebData;
      if (!this.filterUrlValue)
        return result;
      
      const filterUrlValue = this.filterUrlValue.toLowerCase();

      const filter = event => 
          event.url.toLowerCase().includes(filterUrlValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.reports.list.web')" />
    <div class="row">
      <div class="col-xl-4">
        <div class="chat-leftsidebar me-lg-4">
          <div class="search-box py-4" style="width: calc(100% - 50px)">
            <div class="position-relative">
              <input type="text" class="form-control" :placeholder="$t('menuitems.reports.search')" v-model="filterValue"/>
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
            
              <div class="chat-leftsidebar-nav" style="width: calc(100% - 40px)">
              <div class="is-loading">
              <div class="preloader-component" v-show="empLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <b-card-text>
                <div v-if="searchevents.length > 0">
                  <simplebar style="height: calc(100vh - 284px);" id="chat-list">
                    <ul class="list-unstyled chat-list">
                      <li
                        class
                        v-for="data of searchevents"
                        :key="data.empId"
                        @click="onEmployeeChange(data)"
                        :class="{ active: curr.empId == data.empId }"
                      >
                        <a href="javascript: void(0);">
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i
                                :class="`mdi mdi-circle text-${data.color} font-size-10`"
                              ></i>
                            </div>
                            <div class="avatar-xs align-self-center me-3">
                              <span
                                class="
                                  avatar-title
                                  rounded-circle
                                  bg-soft bg-primary
                                  text-primary
                                "
                                >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                {{ data.email }}
                              </p>
                            </div>
                            <!--<div class="font-size-11">{{ data.time }}</div>-->
                          </div>
                        </a>
                      </li>
                    </ul>
                  </simplebar>
                </div>
                <div v-if="searchevents.length <= 0">
                    <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 50%;margin-left: 22%;" height="180" width="180"><br />
                    <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
                </div>
              </b-card-text>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8" >
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
            <div class="is-loading">
              <div class="preloader-component" v-show="webDashboardLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <Stat :icon="stat.icon" :title="$t(stat.title)" :value="stat.value" />
            </div>
          </div>
        </div>

        <!--<div class="is-loading">
          <div class="preloader-component" v-show="hideData">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Web Block</h4>
              <div id="web-chart" class="apex-charts"></div>
              <apexchart
                class="apex-charts"
                type="bar"
                height="320"
                :series="webChart.series"
                :options="webChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>-->

        <div class="card">
          
          <div class="card-body" >
            <div class="row mb-1">
              <div class="col-md-3">
                <h4 class="card-title mb-4">{{ $t('menuitems.reports.webBrowsingLogs') }}</h4>
              </div>
              <div class="col-md-6 text-end">
                <!--<span class="link-primary font-size-17 text-decoration-underline">Export</span>-->
              </div>
              <div class="col-md-3">
                <date-picker
                  v-model="webDate"
                  :first-day-of-week="1"
                  lang="en"
                  @change="onDateChange()"
                ></date-picker>
              </div>
            </div>
            <div class="col-sm-4 search-box mb-2">
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('menuitems.reports.searchUrl')"
                    v-model="filterUrlValue"
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            <div class="is-loading" style="height: calc(100vh - 470px)">
              <div class="preloader-component" v-show="webDataLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <simplebar
                    style="height: calc(100vh - 470px)"
                    ref="current"
                    id="containerElement1"
                    v-if="searchUrlevents.length > 0"
                  >
              <div class="table-responsive" >
                <table class="table table-nowrap table-hover mb-0">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t('menuitems.reports.time') }}</th>
                      <th scope="col">{{ $t('menuitems.reports.urlBrowsed') }}</th>
                    </tr>
                  </thead>
                  
                    <tbody>
                      <tr v-for="(webData, index) in searchUrlevents" :key="index">
                        <th scope="row">{{ webData.time }}</th>
                        <td>
                          <span v-html=" webData.url"
                            ></span
                          >
                        </td>
                      </tr>
                    </tbody>
                  
                </table>
              </div>
              </simplebar>
              <div v-if="searchUrlevents.length <= 0">
                <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 10%;margin-left: 37%;" height="180" width="180"><br />
                <span style="margin-left: 39%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>